import { MouseEventHandler } from 'react';
import CopyActionIcon from '../../icons/actions/CopyActionIcon';
import EditActionIcon from '../../icons/actions/EditActionIcon';
import DeleteActionIcon from '../../icons/actions/DeleteActionIcon';
import SendActionIcon from '../../icons/actions/SendActionIcon';
import DownloadIcon from '../../icons/DownloadIcon';
import XIcon from 'components/icons/XIcon';
import SelectTickIcon from 'components/icons/SelectTickIcon';

export interface TableActionButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  type?: 'edit' | 'copy' | 'delete' | 'sendMail' | 'download' | 'save' | 'cancel';
  className?: string;
  disabled?: boolean;
}

const TableActionButton = ({ onClick, type = 'edit', className, disabled }: TableActionButtonProps) => {
  const types = {
    edit: EditActionIcon,
    copy: CopyActionIcon,
    delete: DeleteActionIcon,
    sendMail: SendActionIcon,
    download: DownloadIcon,
    save: SelectTickIcon,
    cancel: XIcon,
  };

  const Icon = types[type];

  return (
    <button
      data-testid={`table-action-${type}`}
      type='button'
      onClick={onClick}
      className={`group p-2 ${className}`}
      disabled={disabled}>
      <Icon className={`stroke-secondary transition-all ${disabled ? '!stroke-gray-300' : 'group-hover:stroke-primary'}`} />
    </button>
  );
};

export default TableActionButton;
